/*
 * @Author: yaoyuting
 * @Date: 2021-04-23 17:17:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-02 16:39:03
 * @Descripttion:
 */
import {
  get, gets, post, posts,
} from './server.js';
export const base = 'https://www.donetwork.io'//测试
// //  注册
 export const Getadd = p => post('/donet/system/grantApplication/add', p);
// // 登录
// export const Login = p => post('/donet/system/webLogin', p);
// // 忘记密码
// export const UpdatePwd = p => post('/donet/system/user/updatePwd', p);
// // 验证码
// // export const WebLogout = p => get('/donet/system/user/emailVerification', p);
// // 是否绑定钱包
// export const CheckUsersStatus = p => post(`/donet/system/user/checkUsersStatus`,p);
// // 获取账户地址-个人信息展示用
// export const GetUsersAddress = p => post(`/donet/system/user/getUsersAddress`,p);
// // // 绑定钱包
// // export const BindWallet = p => post('/system/user/bindWallet', p);
// // // 获取登录图片
// // export const GetCaptchaImage = p => gets('/system/captcha/captchaImage?type=char', p);
// // // 主网数据概览
// // export const GetProjectOutcome = p => get('/system/getProjectOutcome', p);
// // 核心成员
// export const GetPartnerList = p => post('/donet/system/member/list', p);
// // 官网博客列表
// export const GetBlogList = p => post('/donet/system/blog/webList', p);
// // 博客详情
// export const GetBlogDetail = id => get(`/donet/system/blog/webDetail/${id}`);
// // 订阅
// // export const SubBlog = (blogId,email )=> get(`/donet/system/blog/subBlog/${blogId}/${email}`);

// export const SubBlog = blogId => get(`/donet/system/blog/subBlog/${blogId}`);
// // 邮箱验证码
// export const GetEmail = p => post(`/donet/system/user/emailVerification`,p);
